/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app_store_account: NonNullable<unknown> }} Dialog_Restore_No_Transaction_ContentInputs */

const en_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your current ${i?.app_store_account} has no subscription record.`)
};

const ar_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`حسابك الحالي ${i?.app_store_account} لا يحتوي على سجل اشتراك.`)
};

const de_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ihr aktuelles ${i?.app_store_account} hat keinen Abonnement-Datensatz.`)
};

const es_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu ${i?.app_store_account} actual no tiene registro de suscripción.`)
};

const fr_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre ${i?.app_store_account} actuel n'a pas d'abonnement associé.`)
};

const it_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo attuale ${i?.app_store_account} non ha alcun dato di abbonamento.`)
};

const ja_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在の${i?.app_store_account}にはサブスクリプション記録がありません。`)
};

const ko_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`현재 ${i?.app_store_account}에 구독 기록이 없어요.`)
};

const pt_br_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sua ${i?.app_store_account} atual não possui registro de assinatura.`)
};

const ru_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш текущий ${i?.app_store_account} не содержит записи о подписке.`)
};

const th_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app_store_account} ปัจจุบันของคุณไม่มีบันทึกการสมัครสมาชิก`)
};

const tr_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mevcut ${i?.app_store_account} kapsamında abonelik kaydı yok.`)
};

const zh_cn_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你当前的 ${i?.app_store_account} 并无 Plus 会员购买记录。`)
};

const zh_tw_dialog_restore_no_transaction_content = /** @type {(inputs: Dialog_Restore_No_Transaction_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你當前的 ${i?.app_store_account} 並無訂閱紀錄。`)
};

/**
* | output |
* | --- |
* | "Your current {app_store_account} has no subscription record." |
*
* @param {Dialog_Restore_No_Transaction_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_restore_no_transaction_content = /** @type {((inputs: Dialog_Restore_No_Transaction_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Restore_No_Transaction_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_restore_no_transaction_content(inputs)
	if (locale === "ar") return ar_dialog_restore_no_transaction_content(inputs)
	if (locale === "de") return de_dialog_restore_no_transaction_content(inputs)
	if (locale === "es") return es_dialog_restore_no_transaction_content(inputs)
	if (locale === "fr") return fr_dialog_restore_no_transaction_content(inputs)
	if (locale === "it") return it_dialog_restore_no_transaction_content(inputs)
	if (locale === "ja") return ja_dialog_restore_no_transaction_content(inputs)
	if (locale === "ko") return ko_dialog_restore_no_transaction_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_restore_no_transaction_content(inputs)
	if (locale === "ru") return ru_dialog_restore_no_transaction_content(inputs)
	if (locale === "th") return th_dialog_restore_no_transaction_content(inputs)
	if (locale === "tr") return tr_dialog_restore_no_transaction_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_restore_no_transaction_content(inputs)
	return zh_tw_dialog_restore_no_transaction_content(inputs)
});